export default {"src":"/_next/static/media/Microsoft.52b82761.svg","height":26,"width":118,"blurWidth":0,"blurHeight":0};